import React from "react";

export default function LangBtn(props) {
  return(
    <div onClick={() => props.action(props.code, props.i18nCode)} className="language-button">
    <img src={props.image} className="language-icon" alt="lang-icon"/>
    <span className="language-label">{props.label}</span>
    </div>
  )
}